// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610201147/js/" + chunkId + "." + {"44":"a8b7b22a","225":"498259f1","481":"ed592efc","486":"ace4ca1f","770":"efb4d7ca"}[chunkId] + ".0.08502487939689862.chunk.js";
};